import { FC, useCallback } from "react";
import { FolderIcon } from "@icons";
import { Command } from "@vendor/cmdk/cmdk";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useSettings } from "@components/settings/SettingsProvider";
import { useResolvedNavigationShortcuts } from "@components/navigation/useResolvedNavigationShortcuts";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { useCommands } from "./useCommands";

export const WorkspaceNavigationCommands: FC = () => {
    const navigate = useStateAwareNavigate();
    const { close: closeCommands } = useCommands();
    const { open: openSettings } = useSettings();

    const resolvedShortcuts = useResolvedNavigationShortcuts();

    const handleSelected = useCallback(
        (path: string) => {
            navigate(path);
            closeCommands();
        },
        [closeCommands, navigate],
    );

    return (
        <Command.Group heading="Navigation">
            {resolvedShortcuts
                .filter((shortcut) => shortcut.isEnabled)
                .map((shortcut) => (
                    <CommandItem
                        key={shortcut.id}
                        shortcut={shortcut.keys}
                        onSelect={() => {
                            if (shortcut.action === "settings") {
                                openSettings();
                                closeCommands();
                            } else {
                                handleSelected(shortcut.path);
                            }
                        }}
                    >
                        {shortcut.icon && <shortcut.icon />}
                        {shortcut.label}
                    </CommandItem>
                ))}

            <CommandItem
                onSelect={() => handleSelected("/document-categories")}
            >
                <FolderIcon /> Go to Document Categories
            </CommandItem>
        </Command.Group>
    );
};
